import * as History from 'history'
import * as redux from 'redux'
import * as reduxObservable from 'redux-observable'
import 'rxjs/add/observable/dom/ajax'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/mapTo'
import 'rxjs/add/operator/withLatestFrom'
import {Observable} from 'rxjs/Observable'
import {locationChange, PushAction, ReplaceAction} from './actions'
import {GO_BACK, PUSH, REDIRECT, REPLACE} from './constants'

interface Dependencies {window: any, history: History.History, history$: Observable<History.LocationDescriptorObject>}

export const pushEpic = (
  action$: reduxObservable.ActionsObservable<PushAction>,
  store: redux.Store<any>,
  {history, history$}: Dependencies,
) => action$.ofType(PUSH)
    .do((action: PushAction) => history.push(action.payload))
    .withLatestFrom(history$, (action: PushAction, location: History.LocationDescriptorObject) =>
      locationChange({
        hash: location.hash,
        pathname: location.pathname,
        search: location.search,
      }),
    )

export const replaceEpic = (
  action$: reduxObservable.ActionsObservable<ReplaceAction>,
  store: redux.Store<any>,
  {window, history, history$}: Dependencies,
) => action$.ofType(REPLACE)
    .do((action: ReplaceAction) => window.history.replaceState({}, '', action.payload))
    .mapTo({type: REPLACE + 'D'})

export const redirectEpic = (
  action$: reduxObservable.ActionsObservable<ReplaceAction>,
  store: redux.Store<any>,
  {window}: any,
) => action$.ofType(REDIRECT)
    .do((action: any) => window.location.href = action.payload)
    .mapTo({type: REDIRECT + 'ED'})

export const goBackEpic = (
  action$: reduxObservable.ActionsObservable<redux.Action>,
  store: redux.Store<any>,
  {history, history$}: Dependencies,
) => action$.ofType(GO_BACK)
    .do(() => history.goBack())
    .withLatestFrom(history$, (action: PushAction, location: History.LocationDescriptorObject) =>
      locationChange({
        hash: location.hash,
        pathname: location.pathname,
        search: location.search,
      }),
    )

export const epic = reduxObservable.combineEpics(
  goBackEpic,
  pushEpic,
  redirectEpic,
  replaceEpic,
)



// WEBPACK FOOTER //
// ./src/router/epic.ts